<div class="attachments">
  <h2 class="title">anexos</h2>
  <app-file-upload (eventFilesUpload)="onEventFilesToUpload($event)" [filesToUpload]="filesToUpload" [isVisualization]="isVisualization" *ngIf="!isVisualization"></app-file-upload>
</div>

<div class="attachments-not-found" *ngIf="!haveFiles"> 
  Demanda não possui anexos.
</div>

<div *ngIf="errorDownloadFile">
  <mat-error class="attachment-error-download">
    Falha no processo de download.<br>
    Por favor, tente novamente mais tarde. Caso o problema persista, contate o seu atendimento.
  </mat-error>
</div>

<div class="attachment-container" *ngFor="let file of filesToUpload">
  <div class="attachment-item-box">
    <span class="itau-text-bold attachment-description">{{ file.name }}</span>
    <br>
    <label class="attachment">{{ getSizeText(file) }} </label>
  </div>
  <div class="attachment-button-delete" (click)="deleteAttachment(file.name, $event)">
      <img src="./assets/img/icon-delete.svg" > 
  </div>
</div>
<div *ngIf="haveFiles">
  <div class="attachment-container" *ngFor="let file of listAttachmentsRecent">
      <div class="attachment-item-box">
        <span class="itau-text-bold attachment-description">{{ file.documentName }}</span>
        <label class="attachment">{{ file.updateUserName }} - {{ file.dateTimeRegistration | replace:'-':'/' | date: 'dd/MM/yyyy' }}</label>
        <div *ngIf="file.id" class="attachment-button-download float-right" (click)="downloadOccurenceFileById(file.id)"> 
          <img src="./assets/img/icon_download.svg"> 
        </div>          
    </div>  
</div>